import { useState, useEffect } from "react";
import { useSubdomain } from "./SubdomainProvider.js";
import SocialFooter from "./SocialFooter.js";
import {
  actorDisplayName,
  fetchActors,
  resolveActorImage,
} from "../config/actorAssets.js";

function Debrief() {
  const [oneToggled, setOneToggled] = useState(false);
  const [twoToggled, setTwoToggled] = useState(false);
  const [threeToggled, setThreeToggled] = useState(false);
  const [fourToggled, setFourToggled] = useState(false);
  const [fiveToggled, setFiveToggled] = useState(false);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalActor, setModalActor] = useState(null);

  const [settings, setSettings] = useState(null);
  const [actorsByKey, setActorsByKey] = useState({});
  const subdomain = useSubdomain();
  const API_URL = process.env.REACT_APP_API_URL;

  const handleImageClick = (actor) => {
    setModalActor(actor);
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    setModalActor(null);
  };

  // Clear all localStorage when user visits debrief page
  useEffect(() => {
    localStorage.clear();
  }, []);

  useEffect(() => {
    Promise.all([
      fetch(`${API_URL}/api/settings`).then((res) => res.json()),
      fetchActors(API_URL, subdomain),
    ]).then(([data, actors]) => {
      const activeActorsKey =
        subdomain === "seattle" ? "activeActorsSeattle" : "activeActorsApp";
      const actorRolesKey =
        subdomain === "seattle" ? "actorRolesSeattle" : "actorRolesApp";

      if (!Array.isArray(data[activeActorsKey])) {
        data[activeActorsKey] = [];
      }
      if (!data[actorRolesKey] || typeof data[actorRolesKey] !== "object") {
        data[actorRolesKey] = {};
      }

      setSettings(data);
      setActorsByKey(
        Object.fromEntries(actors.map((actor) => [actor.key, actor]))
      );
    });
  }, [API_URL, subdomain]);

  useEffect(() => {
    if (modalVisible) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => document.body.classList.remove("no-scroll");
  }, [modalVisible]);

  if (!settings) return <div>Loading...</div>;

  const recsObject = (name, url, blurb, order) => {
    return (
      <div className="debrief-recs-object">
        <a
          target="_blank"
          href={url}
          rel="noreferrer"
          className="debrief-link"
        >
          {name}
        </a>
        <br />
        <i>{blurb}</i>
        <br />
        <br />
        What to order?
        <br />
        <div className="debrief-order">-{order}-</div>
      </div>
    );
  };

  const actorRolesKey =
    subdomain === "seattle" ? "actorRolesSeattle" : "actorRolesApp";
  const actorRoles = settings?.[actorRolesKey] || {};

  const getActorsByRole = (role) =>
    Object.keys(actorRoles)
      .filter((key) => actorRoles[key] === role)
      .map((key) => actorsByKey[key])
      .filter(Boolean);

  const marbleActors = getActorsByRole("Marble");
  const handlerActors = getActorsByRole("Handler");

  const renderActorPolaroid = (actor) => {
    const polaroid = resolveActorImage(actor, "polaroid");
    if (!polaroid) return null;

    return (
      <img
        key={actor.key}
        src={polaroid}
        className="debrief-polaroid"
        alt={actorDisplayName(actor)}
        onClick={() => handleImageClick(actor)}
        style={{ cursor: "pointer" }}
      />
    );
  };

  const modalHeadshot = modalActor
    ? resolveActorImage(modalActor, "headshot")
    : null;

  return (
    <div className="pageContent">
      <title>Debrief & Credits</title>
      {subdomain !== "seattle" && (
        <>
      <div className="orangeBar">REVIEW US</div>

      <div className="debrief-main-text">
      If you had a great time, it would be very helpful if you left us a
      review on{" "}
      <a
        href="https://www.tripadvisor.com/UserReviewEdit-g32655-d27950047-Spies_Among_Us_An_Immersive_Adventure-Los_Angeles_California.html"
        target="_blank"
        rel="noreferrer"
        style={{ color: "#f9DF39" }}
      >
        Tripadvisor
      </a>{" "}
      or{" "}
      <a
        href="https://g.page/r/CVzTMbhGamnjEAI/review"
        target="_blank"
        rel="noreferrer"
        style={{ color: "#f9DF39" }}
      >
        Google
      </a>
      !<br />
      <br />
      If you did not have a great time, have feedback, or have an idea on how
      to improve the mission, please tell us{" "}
      <a
        href="https://forms.gle/46bRLZ4QmdgKmGYW6"
        target="_blank"
        rel="noreferrer"
        style={{ color: "#f9DF39" }}
      >
        here
      </a>
      .
      </div>

      <div className="orangeBar">LOCAL RECS</div>

      <div className="debrief-main-text">
        Little Tokyo is full of great spots to check out. You probably
        discovered a few on your mission, but here are some of our favorite
        places in the area!
      </div>

      <div
        className="debriefDropdown"
        onClick={() => setOneToggled(!oneToggled)}
        style={{
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>Drinks N/A</span>
        <span
          style={{
            transform: oneToggled ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s ease",
          }}
        >
          ▼
        </span>
      </div>
      {oneToggled === true && (
        <div style={{ marginTop: "20px" }}>
          {recsObject("TEA MASTER MATCHA CAFE", "https://maps.app.goo.gl/Vn7jLVC814Gy7ats7", "They take matcha VERY seriously", "Matcha Latte")}
          {recsObject("HONEYMEE", "https://maps.app.goo.gl/qk9u16CU19ATEYYV6", "Lots of delicious drinks and ice creams", "Honeycomb Ice Cream")}
        </div>
      )}

      <div className="thinOrangeLine" />

      <div
        className="debriefDropdown"
        onClick={() => setTwoToggled(!twoToggled)}
        style={{
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>Quick Bites</span>
        <span
          style={{
            transform: twoToggled ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s ease",
          }}
        >
          ▼
        </span>
      </div>
      {twoToggled === true && (
        <div style={{ marginTop: "20px" }}>
          {recsObject("BANDIT CHOW MEIN", "https://maps.app.goo.gl/b6rM8sWXJFDSCdD88", "You walked by this food truck a few times today. It is delicious!", "Red Oil Chicken Chow Mein")}
          {recsObject("BUNGRAZE", "https://maps.app.goo.gl/uvb3fGM854rRdU2k9", "They have fresh focaccia dough that they throw into the oven only after you order. Makes for an incredible burger bun!", "Super Smash Burger")}
          {recsObject("NIJIYA MARKET", "https://maps.app.goo.gl/sf2aSv89ck3TNfUx7", "This is the very market you first discovered with the golden statues on the roof! They have everything you could want from a Japanese market.", "Salmon Onigiri")}
        </div>
      )}

      <div className="thinOrangeLine" />

      <div
        className="debriefDropdown"
        onClick={() => setThreeToggled(!threeToggled)}
        style={{
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>Drinks (Alcoholic)</span>
        <span
          style={{
            transform: threeToggled ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s ease",
          }}
        >
          ▼
        </span>
      </div>
      {threeToggled === true && (
        <div style={{ marginTop: "20px" }}>
          {recsObject("THE MERMAID", "https://maps.app.goo.gl/NMrXQfNq6XY7Kbzq7", "Tiki dive bar with refreshing drinks!", "Smokey Eye")}
          {recsObject("WOLF AND CRANE", "https://maps.app.goo.gl/MBAcx7Ki7EVEdE3T6", "Probably the closest rec to you if you just finished the mission. Huge selection of Japanese whiskies and tasty cocktails.", "Beets by Wolf")}
        </div>
      )}

      <div className="thinOrangeLine" />

      <div
        className="debriefDropdown"
        onClick={() => setFourToggled(!fourToggled)}
        style={{
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>Tasty Treats</span>
        <span
          style={{
            transform: fourToggled ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s ease",
          }}
        >
          ▼
        </span>
      </div>
      {fourToggled === true && (
        <div style={{ marginTop: "20px" }}>
          {recsObject("LITTLE TOKYO TAIYAKI", "https://maps.app.goo.gl/T88avFqGYWxqJf7Q8", "Specializing in Taiyaki: freshly grilled dough in the shape of a fish. Pick a filling that sounds good to you.", "Chocolate Taiyaki")}
          {recsObject("TEA MASTER MATCHA CAFE", "https://maps.app.goo.gl/Vn7jLVC814Gy7ats7", "They take matcha VERY seriously and their soft serve is the creamiest.", "Matcha Soft Serve")}
          {recsObject("HONEYMEE", "https://maps.app.goo.gl/qk9u16CU19ATEYYV6", "Lots of delicious drinks and ice creams", "Honeycomb Ice Cream")}
        </div>
      )}

      <div className="thinOrangeLine" />

      <div
        className="debriefDropdown"
        onClick={() => setFiveToggled(!fiveToggled)}
        style={{
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>Sit Down Meals</span>
        <span
          style={{
            transform: fiveToggled ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s ease",
          }}
        >
          ▼
        </span>
      </div>
      {fiveToggled === true && (
        <div style={{ marginTop: "20px" }}>
          {recsObject("IZAKAYA GAZEN", "https://maps.app.goo.gl/y2ArQaL7bTpSu3Vv7", "Huge menu, great sake list. Everything from sushi to shabu shabu to noodles.", "Signature Tofu Sampler")}
          {recsObject("MEN OH TOKUSHIMA RAMEN", "https://maps.app.goo.gl/9Z8LxESvLfm597te9", "Super tasty pork bone broth cooked for 16 hours! Ask for free togarashi to sprinkle on top.", "Tokushima Ramen")}
          {recsObject("SHIN-SEN-GUMI HAKATA RAMEN", "https://maps.app.goo.gl/wHAwj2jXGbWjSH7P6", "Great ramen with lots of topping options", "Spicy Hakata Dandan Men Ramen")}
          {recsObject("BADMAASH", "https://maps.app.goo.gl/hcLXCQqZzFNmWeNV9", "Classic Indian menu spruced up with inventive fusion items", "Goan Pork Curry")}
        </div>
      )}

      <div className="thinOrangeLine" />

      <br />
      <br />
      <br />
      <br />
      <br />
      </>)}

      <div className="orangeBar">CREDITS</div>

      {marbleActors.length > 0 && (
        <>
          <div className="debrief-main-text">
            AGENT MARBLE
            <br />
            (tap image to reveal)
          </div>
          {marbleActors.map((actor) => renderActorPolaroid(actor))}
        </>
      )}

      {handlerActors.length > 0 && (
        <>
          <div
            className="debrief-main-text"
            style={{ marginTop: marbleActors.length > 0 ? "20px" : "0" }}
          >
            HANDLER
            <br />
            (tap image to reveal)
          </div>
          {handlerActors.map((actor) => renderActorPolaroid(actor))}
        </>
      )}

      {modalVisible && modalActor && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            overflow: "auto",
          }}
        >
          <div
            style={{
              background: "#21174C",
              width: "100%",
              height: "100%",
              overflowY: "auto",
            }}
          >
            <button
              onClick={closeModal}
              style={{
                position: "absolute",
                top: "1vw",
                right: "1vw",
                background: "transparent",
                border: "none",
                fontSize: "15vw",
                cursor: "pointer",
                color: "white",
              }}
            >
              &times;
            </button>
            <div>
              {modalHeadshot && (
                <img
                  src={modalHeadshot}
                  className="debrief-headshot"
                  alt={actorDisplayName(modalActor)}
                />
              )}
              <div
                className="debrief-bio"
                dangerouslySetInnerHTML={{ __html: modalActor.bio || "" }}
              />
            </div>
          </div>
        </div>
      )}

      <div className="orangeLine" />
      <br />
      <br />
      <br />
      <div className="debrief-titles">Agent Shale Voice Work</div>
      <div className="debrief-names">
        <a
          href="https://www.thetarotnerd.com/"
          target="_blank"
          rel="noreferrer"
          style={{ color: "white" }}
        >
          Tosca Minotto
        </a>
      </div>
      <br />
      <br />
      <div className="debrief-titles">Agent Shale Model</div>
      <div className="debrief-names">Kitty Medina</div>
      <br />
      <br />
      <div className="debrief-titles">Agent Leslie Voice Work</div>
      <div className="debrief-names">
        <a
          href="https://www.instagram.com/momstomppodcast/?hl=en"
          target="_blank"
          rel="noreferrer"
          style={{ color: "white" }}
        >
          Jo Scott
        </a>
      </div>
      <br />
      <br />
      <div className="debrief-titles">Agent Papyrus Voice Work</div>
      <div className="debrief-names">Prescott Gadd</div>
      <br />
      <br />
      <div className="debrief-titles">Agent Papyrus Model</div>
      <div className="debrief-names">Peter Scott</div>
      <br />
      <br />
      <br />
      <div className="orangeLine" />
      <br />
      <br />
      <br />
      <div className="debrief-titles">Created by</div>
      <div className="debrief-names">Prescott Gadd</div>
      <br />
      <br />
      <div className="debrief-titles">Senior Developer</div>
      <div className="debrief-names">
        <a
          href="https://www.linkedin.com/in/nickjohnson-losangeles/"
          target="_blank"
          rel="noreferrer"
          style={{ color: "white" }}
        >
          Nick Johnson
        </a>
      </div>
      <br />
      <br />
      <div className="debrief-titles">Operations by</div>
      <div className="debrief-names">Jen Staben</div>
      <br />
      <br />
      <div className="debrief-titles">Art and Design by</div>
      <div className="debrief-names">
        <a
          href="https://ccalleo.com/"
          target="_blank"
          rel="noreferrer"
          style={{ color: "white" }}
        >
          Curtiss Calleo
        </a>
      </div>
      <br />
      <br />
      <div className="debrief-titles">Special thanks to</div>
      <div className="debrief-names">
        <a
          href="https://williamoconnell.me/"
          target="_blank"
          rel="noreferrer"
          style={{ color: "white" }}
        >
          William O'Connell / Subtext Game
        </a>
      </div>
      <div className="debrief-titles">for tech advice</div>
      <br />
      <br />
      <br />

      <div className="orangeLine" />

      <div className="debrief-names">
        <br />
        Thank you to our playtesters...
        <br />
        <br />
        John Anderson
        <br />
        Molly Anderson
        <br />
        Emily Bell
        <br />
        Benjamin Berk
        <br />
        Brian Biancardi
        <br />
        David Bjånes
        <br />
        Eric Braband
        <br />
        Serena Bright
        <br />
        Jonathan Cloughsey
        <br />
        Becky Cumberland
        <br />
        Marlee Delia
        <br />
        Annie Donley
        <br />
        Rachel Donley
        <br />
        Valerie Gansel
        <br />
        Dustin Giallanza
        <br />
        Alex Haney
        <br />
        Tim Heurlin
        <br />
        Tommy Honton
        <br />
        Kevin Horst
        <br />
        Jared Jeffries
        <br />
        James Jelin
        <br />
        Tim Lamphier
        <br />
        Jes McBride
        <br />
        Phil Meister
        <br />
        Geremy Mumenthaler
        <br />
        Jeff Murdoch
        <br />
        Anne Nemer
        <br />
        Jordan Nomura
        <br />
        Erin Rein
        <br />
        Chelsea Richer
        <br />
        James Ross
        <br />
        Kate Ross
        <br />
        Louis Ross
        <br />
        Tyler Samples
        <br />
        Harold Scissors
        <br />
        Christine Shedd-Thompson
        <br />
        Mary Beth Smith
        <br />
        Jen Staben
        <br />
        Victoria Strange
        <br />
        Meaghan Strickland
        <br />
        Corey Topkis
        <br />
        Jake Topkis
        <br />
        Nina Zhao
      </div>

      <SocialFooter />
    </div>
  );
}

export default Debrief;
